import { combineReducers } from "redux";
import authReducer from "../features/auth/authSlice";
import worksheetListReducer from "../features/worksheets/worksheetListSlice";
import worksheetReducer from "../features/worksheets/worksheetSlice";
import uiReducer from "../features/ui/uiSlice";
import studentReducer from "../features/student/studentSlice";
import assignedWorksheetListReducer from "../features/worksheets/assignedWorksheetListSlice";
import assignmentListReducer from "../features/worksheets/assignmentListSlice";
import adminReducer from "../features/admin/adminSlice";
import notificationReducer from "../features/notification/notificationSlice";
import paperAssignmentReducer from "../features/paper-assignment/paperAssignmentSlice";

const rootReducer = combineReducers({
  auth: authReducer,
  worksheets: worksheetListReducer,
  worksheet: worksheetReducer,
  assigned_worksheets: assignedWorksheetListReducer,
  ui: uiReducer,
  student: studentReducer,
  assignments: assignmentListReducer,
  admin: adminReducer,
  notification: notificationReducer,
  paperAssignment: paperAssignmentReducer,
});

export default rootReducer;
